import React, { useState, useEffect } from "react";
import "./index.css"; // or "./App.css"

const API_URL = "https://comethru-backend.onrender.com/api/messages";

function App() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [alias] = useState(() => "Anon" + Math.floor(Math.random() * 10000));
  const [showAccountForm, setShowAccountForm] = useState(false); // ✅ moved inside the component

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const res = await fetch(API_URL, { mode: "cors" });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        setMessages(data);
      } catch (err) {
        console.error("Error fetching messages:", err);
      }
    };
    fetchMessages();
  }, []);

  const sendMessage = async () => {
    if (!input.trim()) return;
    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        mode: "cors",
        body: JSON.stringify({ author: alias, content: input }),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const newMsg = await res.json();
      setMessages((prev) => [...prev, newMsg]);
      setInput("");
    } catch (err) {
      console.error("Error sending message:", err);
      alert("Could not send message — check console for details.");
    }
  };

  return (
    <div className="App">
      {/* LEFT SIDEBAR */}
      <div className="sidebar">
        <h2>ComeThru 💬</h2>
        <div className="profile">
          <div className="profile-name">{alias}</div>
          <div className="profile-desc">
            Anonymous chatter. Say anything, freely.
          </div>
        </div>

        {/* ✅ Create Account Button */}
        <button
          className="create-account-btn"
          onClick={() => setShowAccountForm(true)}
        >
          Create Account
        </button>
      </div>

      {/* MAIN CHAT AREA */}
      <div className="chat">
        <div className="chat-header">Live Chat Room</div>

        <div className="messages-box">
          {messages.length === 0 ? (
            <p style={{ color: "#555", textAlign: "center" }}>
              No messages yet...
            </p>
          ) : (
            messages.map((m) => (
              <div key={m.id} className="message">
                <strong>{m.author}</strong> {m.content}
              </div>
            ))
          )}
        </div>

        <div className="input-row">
          <input
            type="text"
            value={input}
            placeholder="Type a message..."
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && sendMessage()}
          />
          <button onClick={sendMessage}>Send</button>
        </div>
      </div>

      {/* ✅ Optional popup placeholder */}
      {showAccountForm && (
        <div className="account-popup">
          <h3>Create Account</h3>
          <p>Feature under development!</p>
          <button onClick={() => setShowAccountForm(false)}>Close</button>
        </div>
      )}
    </div>
  );
}

export default App;
